import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-brand-cream relative overflow-hidden" data-id="element-172">
      {/* Decorative background circle */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-3xl -z-10" data-id="element-173"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green" data-id="element-176">
            No vas a pagar{' '}
            <span className="line-through text-brand-red/80" data-id="element-177">$422</span>.
          </h2>
          <p className="text-xl md:text-2xl text-brand-gray/80 mb-8 max-w-2xl mx-auto" data-id="element-178">
            Ni siquiera vas a pagar los $37 que costará este programa en 72
            horas.
          </p>
          <p className="text-lg text-brand-gray/70 italic border-b border-brand-gold/30 pb-8 inline-block" data-id="element-179">
            Porque mi misión es ayudar a 10,000 mujeres a recuperar su brillo
            este año...
          </p>
        </motion.div>

        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-2xl border-2 border-brand-gold relative max-w-2xl mx-auto" data-id="element-180">
          {/* Badge */}
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-brand-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wider shadow-lg whitespace-nowrap" data-id="element-181">
            🔥 Solo por 72 Horas
          </div>

          <p className="text-brand-gray/60 uppercase tracking-widest font-semibold mb-2" data-id="element-182">
            Tu Precio Hoy
          </p>

          {/* Before price */}
          <div className="flex justify-center items-center gap-3 mb-3" data-id="element-183">
            <span className="text-2xl md:text-3xl text-brand-gray/40 line-through font-semibold" data-id="element-184">
              $422
            </span>
            <span className="bg-brand-red text-white text-sm md:text-base font-bold px-3 py-1 rounded-full" data-id="element-185">
              -96% OFF
            </span>
          </div>

          {/* Current price */}
          <div className="flex justify-center items-baseline gap-2 mb-2" data-id="element-186">
            <span className="text-6xl md:text-8xl font-black text-brand-green tracking-tighter" data-id="element-187">
              $17
            </span>
            <span className="text-xl text-brand-gray/50 font-medium" data-id="element-188">USD</span>
          </div>

          <p className="text-sm text-brand-green/70 font-semibold mb-8" data-id="element-189">
            ¡Ahorras $405 hoy!
          </p>

          <p className="text-brand-gray/70 mb-10 text-lg" data-id="element-190">
            (Menos de lo que cuesta una cena fuera que probablemente inflamará
            tus hormonas).
          </p>

          <CTAButton className="mb-6" href="https://optilatammarket.com/cart/42615614439522:1" data-id="element-191">
            SÍ, QUIERO EL CÓDIGO HORMONAL
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-6 text-brand-gray/60 text-sm mt-8" data-id="element-192">
            <div className="flex items-center gap-2" data-id="element-193">
              <ShieldCheck className="w-5 h-5 text-brand-green" data-id="element-194" />
              <span data-id="element-195">Acceso Inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-196">
              <Lock className="w-5 h-5 text-brand-green" data-id="element-197" />
              <span data-id="element-198">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-199">
              <CreditCard className="w-5 h-5 text-brand-green" data-id="element-200" />
              <span data-id="element-201">Tarjetas / PayPal</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}